/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminGroupSaleMarketplace,
    AdminGroupSaleMarketplaceFromJSON,
    AdminGroupSaleMarketplaceFromJSONTyped,
    AdminGroupSaleMarketplaceToJSON,
} from './AdminGroupSaleMarketplace';
import {
    AdminGroupSaleStatus,
    AdminGroupSaleStatusFromJSON,
    AdminGroupSaleStatusFromJSONTyped,
    AdminGroupSaleStatusToJSON,
} from './AdminGroupSaleStatus';

/**
 * 
 * @export
 * @interface AdminUpdateGroupSale
 */
export interface AdminUpdateGroupSale {
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateGroupSale
     */
    id?: string;
    /**
     * 
     * @type {Array<AdminGroupSaleMarketplace>}
     * @memberof AdminUpdateGroupSale
     */
    marketplaces?: Array<AdminGroupSaleMarketplace>;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateGroupSale
     */
    name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminUpdateGroupSale
     */
    productIDs?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateGroupSale
     */
    soldDate?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateGroupSale
     */
    soldPrice?: number;
    /**
     * 
     * @type {AdminGroupSaleStatus}
     * @memberof AdminUpdateGroupSale
     */
    status?: AdminGroupSaleStatus;
}



export function AdminUpdateGroupSaleFromJSON(json: any): AdminUpdateGroupSale {
    return AdminUpdateGroupSaleFromJSONTyped(json, false);
}

export function AdminUpdateGroupSaleFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminUpdateGroupSale {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'marketplaces': !exists(json, 'marketplaces') ? undefined : ((json['marketplaces'] as Array<any>).map(AdminGroupSaleMarketplaceFromJSON)),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'productIDs': !exists(json, 'productIDs') ? undefined : json['productIDs'],
        'soldDate': !exists(json, 'soldDate') ? undefined : json['soldDate'],
        'soldPrice': !exists(json, 'soldPrice') ? undefined : json['soldPrice'],
        'status': !exists(json, 'status') ? undefined : AdminGroupSaleStatusFromJSON(json['status']),
    };
}

export function AdminUpdateGroupSaleToJSON(value?: AdminUpdateGroupSale | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'marketplaces': !value.marketplaces ? undefined : ((value.marketplaces as Array<any>).map(AdminGroupSaleMarketplaceToJSON)),
        'name': value.name,
        'productIDs': value.productIDs,
        'soldDate': value.soldDate,
        'soldPrice': value.soldPrice,
        'status': AdminGroupSaleStatusToJSON(value.status),
    };
}

